import { getChildren } from "apis";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { ChildrenState, fetchChildren } from "store/features/children";

const useChildren = () => {
  const dispatch = useDispatch();
  const { loaded, items, selected } = useSelector<RootState, ChildrenState>(
    (store) => store.children,
  );

  useEffect(() => {
    if (loaded) return;

    getChildren().then((data) => {
      dispatch(fetchChildren(data || []));
    });
  }, [loaded, dispatch]);
  return { loaded, children: items, selected };
};

export default useChildren;
